import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import SelectDropDown from "./SelectDropDown";
import InputTextSearch from "./InputTextSearch";
import { useLocation } from "react-router-dom";
import {
  DATE_FILTER_POPPER_CLASS,
  DateFilterHeading,
  DateFilterPresets,
} from "./DateFilterParts";

// Reorder report filters that search by name, and the report types that always
// show the search row (their Search button lives there instead of beside Outlet).
const REORDER_SEARCH_FILTER_TYPES = [
  "Product",
  "Brand",
  "Vendor",
  "Category",
  "Out of stock",
  "Low inventory",
  "All inventory",
  "On-hand-inventory",
];
const SEARCH_ROW_REPORT_TYPES = [
  "inventory-performance",
  "recently-out-of-stock",
  "sell-through",
  "inventory-summary",
  "quantity-history-report",
  "current-inventory-value",
  "instant-activity",
  "stocktake-history-report",
];

const DashDateRangeComponent = ({
  onDateRangeChange,
  onSelectedReportType,
  selectedDateRange,
  future_date,
}) => {

  const today = new Date();
  const yesterday = new Date(today);
  // yesterday.setDate(today.getDate() - 1);
  yesterday.setDate(today.getDate());
  const last7DaysStart = new Date(today);
  // last7DaysStart.setDate(today.getDate() - 7);
  last7DaysStart.setDate(today.getDate() - 6);
  const [startDate, setStartDate] = useState(today);
  const [endDate, setEndDate] = useState(yesterday);
  const [futureDateState, setFutureDate] = useState(new Date() - 1);
  const [searchRecord, setSearchRecord] = useState("");
  const [filterReportType, setReportType] = useState("Product");
  const handleSearchInputChange = (value) => {
    setSearchRecord(value);
  };
  // console.log("..........onSelec..........tedReportType", onSelectedReportType);

  const location = useLocation();
  const pathSegments = location.pathname.split("/"); // Split the path into segments
  const reportType = pathSegments[pathSegments.length - 1]; // Get the last segment
  // console.log("reportType", reportType);


  const handleSearch = () => {
    const formatDate = (date) => {
      return new Intl.DateTimeFormat("en-CA", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      }).format(date);
    };

    const formattedStartDate = formatDate(startDate);
    const formattedEndDate = formatDate(endDate);
    const dateRangeData = {
      start_date: formattedStartDate,
      end_date: formattedEndDate,
      search_by: searchRecord.trim(),
    };

    onDateRangeChange(dateRangeData);
  };

  const [activeOption, setActiveOption] = useState("Today");

  const setActive = (option) => {
    setActiveOption(option);
  };

  const isActive = (option) => {
    return option === activeOption;
  };

  const setDatesBasedOnOption = (option) => {
    const today = new Date();
    // Clear the search input
    setSearchRecord("");
    switch (option) {
      case "Today":
        setStartDate(today);
        setEndDate(today);
        break;
      case "Yesterday":
        const yesterday = new Date(today);
        yesterday.setDate(today.getDate() - 1);
        setStartDate(yesterday);
        setEndDate(yesterday);
        break;
      case "Last 7 Days":
        const last7Days = new Date(today);
        const dayBefore = new Date(today);
        // last7Days.setDate(today.getDate() - 7);
        last7Days.setDate(today.getDate() - 6);
        // dayBefore.setDate(today.getDate() - 1);
        dayBefore.setDate(today.getDate());
        setStartDate(last7Days);
        setEndDate(dayBefore);
        break;
      case "Last 30 Days":
        const last30Days = new Date(today);
        const dayfor30 = new Date(today);
        // last30Days.setDate(today.getDate() - 30);
        // dayfor30.setDate(today.getDate() - 1);
        last30Days.setDate(today.getDate() - 29);
        dayfor30.setDate(today.getDate());
        setStartDate(last30Days);
        setEndDate(dayfor30);
        break;
      default:
        break;
    }
  };
  useEffect(() => {
    const today = new Date();
    let gotFurureDate = new Date();
    future_date &&
      setFutureDate(
        gotFurureDate.setDate(today.getDate() + (parseInt(future_date) + 1))
      );
  }, [future_date]);
  useEffect(() => {
    if (reportType !== "stocktake-history-report") {
      return;
    }

    if (selectedDateRange && selectedDateRange.start_date && selectedDateRange.end_date) {
      const parseDate = (dateStr) => {
        if (!dateStr || typeof dateStr !== "string") return null;
        const parts = dateStr.split("-");
        if (parts.length !== 3) return null;
        const [year, month, day] = parts.map((v) => parseInt(v, 10));
        if (!year || !month || !day) return null;
        const parsed = new Date(year, month - 1, day);
        if (isNaN(parsed.getTime())) return null;
        return parsed;
      };

      const parsedStart = parseDate(selectedDateRange.start_date);
      const parsedEnd = parseDate(selectedDateRange.end_date);

      if (parsedStart) {
        setStartDate(parsedStart);
      }
      if (parsedEnd) {
        setEndDate(parsedEnd);
      }
    }

    if (
      selectedDateRange &&
      Object.prototype.hasOwnProperty.call(selectedDateRange, "search_by") &&
      typeof selectedDateRange.search_by === "string"
    ) {
      setSearchRecord(selectedDateRange.search_by);
    }
  }, [selectedDateRange, reportType]);
  useEffect(() => {
    // console.log("change", onSelectedReportType);
    if (onSelectedReportType && onSelectedReportType.title) {
      setReportType(onSelectedReportType.title);
    }
  }, [onSelectedReportType]);

  useEffect(() => {
    if (reportType === "stocktake-history-report") {
      return;
    }

    handleSearch();

    setDatesBasedOnOption(activeOption);
  }, [activeOption, reportType]);

  const [selectedReportList, setSelectedReportList] = useState("Main Outlet");

  const selectReportList = [
    {
      title: "Main Outlet",
    },
    {
      title: "Location",
    },
    {
      title: "Category",
    },
  ];

  const handleOptionClick = (option, dropdown) => {
    console.log(option, dropdown);
    switch (dropdown) {
      case "reportList":
        setSelectedReportList(option.title);
        // setSearchRecord("");
        break;

      default:
        break;
    }
  };

  // Report types whose filters need a search box: Search moves to that row.
  const showSearchRow =
    (reportType === "recorder-inventory" &&
      filterReportType &&
      REORDER_SEARCH_FILTER_TYPES.includes(filterReportType)) ||
    SEARCH_ROW_REPORT_TYPES.includes(reportType);

  const searchLabel =
    reportType === "stocktake-history-report"
      ? "Search Stocktake"
      : reportType === "inventory-summary"
        ? "Search Product by Title"
        : filterReportType === "Brand"
          ? "Search by Brand"
          : filterReportType === "Product"
            ? "Search by Product"
            : filterReportType === "Vendor"
              ? "Search by Vendor"
              : filterReportType === "Category"
                ? "Search by Category"
                : "Search Products";

  const searchPlaceholder =
    reportType === "stocktake-history-report"
      ? "Search Stocktake by ID or Employee Name"
      : filterReportType === "Brand"
        ? "Search by Brand"
        : filterReportType === "Product"
          ? "Search Product by Title"
          : filterReportType === "Vendor"
            ? "Search by Vendor"
            : filterReportType === "Category"
              ? "Search by Category"
              : "Search Products by Title";

  return (
    <div className="q-datarange-bottom-detail-section qv-date-filter">
      <DateFilterHeading />
      <DateFilterPresets
        isActive={isActive}
        onSelect={(option) => {
          setActive(option);
          setDatesBasedOnOption(option);
        }}
      />

      <div className="qv-date-filter__fields">
        <div className="qv-date-filter__field">
          <label htmlFor="inv-report-start-date" className="qv-date-filter__label">
            Start Date
          </label>
          <DatePicker
            id="inv-report-start-date"
            selected={startDate}
            onChange={(date) => setStartDate(date)}
            selectsStart
            startDate={startDate}
            endDate={endDate}
            maxDate={endDate}
            dateFormat="MM/dd/yyyy"
            placeholderText="MM/DD/YYYY"
            className="qv-date-filter__input"
            showPopperArrow={false}
            popperPlacement="bottom-start"
            popperClassName={DATE_FILTER_POPPER_CLASS}
          />
        </div>
        <div className="qv-date-filter__field">
          <label htmlFor="inv-report-end-date" className="qv-date-filter__label">
            End Date
          </label>
          <DatePicker
            id="inv-report-end-date"
            selected={endDate}
            onChange={(date) => setEndDate(date)}
            selectsEnd
            startDate={startDate}
            endDate={endDate}
            minDate={startDate}
            maxDate={futureDateState ? futureDateState : new Date()}
            dateFormat="MM/dd/yyyy"
            placeholderText="MM/DD/YYYY"
            className="qv-date-filter__input"
            showPopperArrow={false}
            popperPlacement="bottom-start"
            popperClassName={DATE_FILTER_POPPER_CLASS}
          />
        </div>
        <div className="qv-date-filter__field">
          <span className="qv-date-filter__label">Outlet</span>
          <SelectDropDown
            listItem={selectReportList}
            onClickHandler={handleOptionClick}
            selectedOption={selectedReportList}
            dropdownFor={"reportList"}
            title={"title"}
            disabled
          />
        </div>
        {!showSearchRow && (
          <div className="qv-date-filter__field qv-date-filter__field--action">
            <button type="button" onClick={handleSearch} className="save_btn">
              Search
            </button>
          </div>
        )}
      </div>

      {showSearchRow && (
        <div className="qv-date-filter__search">
          <span className="qv-date-filter__label">{searchLabel}</span>
          <div className="qv-date-filter__search-row">
            <InputTextSearch
              value={searchRecord}
              handleChange={handleSearchInputChange}
              handlefocus={(e) => {
                if (e.key === "Enter") {
                  handleSearch();
                  e.target.blur();
                }
              }}
              placeholder={searchPlaceholder}
            />
            <button type="button" onClick={handleSearch} className="save_btn">
              Search
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default DashDateRangeComponent;
